module.exports = __webpack_public_path__ + "img/hover_icon_jornal_de_pagos.b4036e9e.svg";